import React from 'react';
import { ThemeProvider } from '@mui/material';
import theme from './Theme/theme';
import SubnetCalculator from './Component/subnetCalculator';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
        <SubnetCalculator />
     </ThemeProvider>
   );
}

export default App;
